module.exports = __webpack_public_path__ + "img/cm.2fdf313f.svg";